import {useId} from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {PRICES_HUB_DATA_SOURCES} from "../../constants/prices_hub_data_sources";
import {PricesHubDataSourcesCards} from "./PricesHubDataSourcesCards";
import {PricesHubDataSourcesNote} from "./PricesHubDataSourcesNote";
import {PricesHubDataSourcesTable} from "./PricesHubDataSourcesTable";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubDataSources = () => {
    const headingId = useId();
    const {isMobile} = useUserDevice();

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="data_sources" />

            <Container maxWidthVariant="lg">
                <div className={innerStyle}>
                    <Text id={headingId} as="h2" variant="headline_3" strong className={headingStyle}>
                        Skąd pochodzą dane i jak je interpretować?
                    </Text>

                    <Text as="p" variant="body_copy_1" align="center" className={leadStyle}>
                        Ceny mieszkań można mierzyć na różne sposoby. Dlatego korzystamy z dwóch niezależnych źródeł danych, które pokazują rynek z innej
                        perspektywy.
                    </Text>

                    {isMobile ? (
                        <PricesHubDataSourcesCards sources={PRICES_HUB_DATA_SOURCES} />
                    ) : (
                        <PricesHubDataSourcesTable sources={PRICES_HUB_DATA_SOURCES} />
                    )}

                    <PricesHubDataSourcesNote />
                </div>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,
    backgroundColor: "var(--colors-gray-100)",

    md: {
        py: 8
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    maxWidth: "127.2rem",
    mx: "auto",

    md: {
        gap: 3
    }
});

const headingStyle = css({
    width: "100%",
    margin: 0,
    color: "var(--colors-secondary)",
    textAlign: "left",

    md: {
        textAlign: "center"
    }
});

const leadStyle = css({
    maxWidth: "90rem",
    margin: 0,
    color: "var(--colors-gray-700)"
});
import {useId} from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {PRICES_HUB_DATA_SOURCES} from "../../constants/prices_hub_data_sources";
import {PricesHubDataSourcesCards} from "./PricesHubDataSourcesCards";
import {PricesHubDataSourcesNote} from "./PricesHubDataSourcesNote";
import {PricesHubDataSourcesTable} from "./PricesHubDataSourcesTable";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubDataSources = () => {
    const headingId = useId();
    const {isMobile} = useUserDevice();

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="data_sources" />

            <Container maxWidthVariant="lg">
                <div className={innerStyle}>
                    <Text id={headingId} as="h2" variant="headline_3" strong className={headingStyle}>
                        Skąd pochodzą dane i jak je interpretować?
                    </Text>

                    <Text as="p" variant="body_copy_1" align="center" className={leadStyle}>
                        Ceny mieszkań można mierzyć na różne sposoby. Dlatego korzystamy z dwóch niezależnych źródeł danych, które pokazują rynek z innej
                        perspektywy.
                    </Text>

                    {isMobile ? (
                        <PricesHubDataSourcesCards sources={PRICES_HUB_DATA_SOURCES} />
                    ) : (
                        <PricesHubDataSourcesTable sources={PRICES_HUB_DATA_SOURCES} />
                    )}

                    <PricesHubDataSourcesNote />
                </div>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,
    backgroundColor: "var(--colors-gray-100)",

    md: {
        py: 8
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    maxWidth: "127.2rem",
    mx: "auto",

    md: {
        gap: 3
    }
});

const headingStyle = css({
    width: "100%",
    margin: 0,
    color: "var(--colors-secondary)",
    textAlign: "left",

    md: {
        textAlign: "center"
    }
});

const leadStyle = css({
    maxWidth: "90rem",
    margin: 0,
    color: "var(--colors-gray-700)"
});
